import { SecuredAPMProxyClient } from '../../../Core/Api/APMProxy/SecuredAPMProxyClient';
import { StrippingScheduleModel } from './Models/StrippingScheduleModel';
import moment from 'moment';

export class StrippingScheduleHandler {
  props: any;
  constructor(props) {
    this.props = props;
  }

  GetStrippingSchedule(strippingScheduleModel: StrippingScheduleModel) {
    const client = new SecuredAPMProxyClient();
    client.showLoading = true;
    client.DisableToken = true;
    client.handleGeneralError = false;
    const expectedStrippingDate = !strippingScheduleModel.stripDate
      ? undefined
      : moment(strippingScheduleModel.stripDate).format('YYYYMMDD');
    const containerNumber = strippingScheduleModel['containerNumber'];
    return client.getStrippingSchedule(containerNumber, expectedStrippingDate).then(response => {
      return response.data;
    });
  }
}
